import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

/**
 * @member [reportCommentsService] reportCommentsService
 */
var adminnotesService;

/**
 * Object Picture service, manages pictures
 * @module services/reportCommentsService
 * @returns [reportCommentsService]
 */

export default function () {

    /**
     * Assigns ReportComments class with properties
     * @member [ReportComments] ReportCommentsModel
     */
    var adminnotesModel = Model.extend({
        className: "AdminNotes",
        defaults: {
            'manualTitle': false,
        }
    });

    /**
     * Represents a collection of ReportComments
     * @member [ReportComments collection] ReportCommentCollection
     */
    var adminnotesCollection = Collection.extend({
        model: adminnotesModel
    });

    /**
     * it's ReportCommentsModel service, object type service of the collection
     * @member [ReportComments Service] ReportCommentsService
     */
    var AdminnotesService = ParseService.extend({
        sortBy: 'createdAt',
        order: 'dsc',
        model: adminnotesModel,
        collection: adminnotesCollection,
		setAdminNote:function(reportID, auditor, note, xl){
			var Adminnote = Parse.Object.extend("AdminNotes");
			var adminnote = new Adminnote();
			adminnote.set("report",reportID);
			adminnote.set("note",note);
			adminnote.set("auditor",auditor);
			adminnote.save(null, {
				success: function(adminnote) {
					window.localStorage.adminnoteid = '';
					window.localStorage.adminnoteid = adminnote.id;
                    xl(adminnote);
				},
				error: function(adminnote, error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
                        default:
                            if(arrlang[lang][error.message]){
                                toastr.error(arrlang[lang][error.message], "Error");
                            }
                            else{
                                toastr.error('Nota de Auditor no guardada, hubo un problema con la red.', "Error");	
                            }
                        break;
					}
				}
			});
         },
        // you can also extend any method from ParseService here
    });

    return adminnotesService || (adminnotesService = new AdminnotesService());
};
